import { ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { ServiceDeleteBase } from "../../../shared/services/base/ServiceDeleteBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { CultivoService } from "./CultivoService";

/** Baja de cultivos de proyecto; la saca del listado en memoria. */
export class CultivoDeleteService extends ServiceDeleteBase {
  protected readonly cache = CultivoService.instance;

  /** gRPC-Web (`EliminarCultivo`): baja lógica. Falla si el cultivo tiene ítems de catálogo o proyectos. */
  protected async sendDelete(id: string): Promise<void> {
    await grpcCall(() => grpcClient(ProyectosPlataformaService).eliminarCultivo({ id }));
  }
}
